import type { ArtistSectionKey } from '../getArtistSections';
import { page } from '$app/state';
import { replaceShallowState } from '$global/utils/replaceShallowState/replaceShallowState';

/**
 * Persists the section's loaded-item count into the current history entry
 * (shallow-routing state) so back/forward navigation restores every
 * "Show more" click. History-entry state rather than a snapshot because
 * SvelteKit applies `page.state` before it restores the scroll position,
 * while snapshots are restored after — too late for the page to have its
 * expanded height when the saved scroll offset is applied.
 */
export const setArtistSectionCount = (key: ArtistSectionKey, count: number) => {
	replaceShallowState('', {
		...page.state,
		artistSectionCounts: {
			...page.state?.artistSectionCounts,
			[key]: count,
		},
	});
};
